<template>
  <ItemList />
  <Teleport to="#dynamic-archive-elements">
    <FilterElements />
  </Teleport>
  <Teleport v-for="taxonomy in itemStore.taxonomies" :to="'#' + taxonomy.id" :key="taxonomy.id">
    <FilterButtons v-if="taxonomy.type === 'buttons'" :taxonomy="taxonomy.name" />
    <FilterDropdown
      v-else-if="taxonomy.type === 'dropdown'"
      :taxonomy="taxonomy.name"
      :placeholder="taxonomy.placeholder"
      :root="taxonomy.root"
    />
  </Teleport>
</template>

<script lang="ts" setup>
import ItemList from "@/components/ItemList.vue";
import FilterElements from "@/components/FilterElements.vue";
import FilterButtons from "@/components/FilterButtons.vue";
import FilterDropdown from "@/components/FilterDropdown.vue";
import { useItemStore } from "@/itemStore";

const itemStore = useItemStore();
</script>
